import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SuperTabsModule } from '@ionic-super-tabs/angular';
import { IonicModule } from '@ionic/angular';
import { IdlPipeModule } from '../../pipes/idlPipes.module';
import { ActesModule } from '../actes/actes.module';
import { OlaqinModule } from '../olaqin/olaqin.module';
import { OrdonnancesModule } from '../ordonnances/ordonnances.module';
import { PatientsModule } from '../patients/patients.module';
import { CustomPaginator } from './customPaginator';
import { FacturationService } from './facturation.service';
import { TourneesModule } from '../tournees/tournees.module';
import { PipeModule } from '../../pipes';

@NgModule({
	declarations: [
	],
	exports: [
	],
	imports: [
		CommonModule,
		SuperTabsModule,
		IonicModule,
		ActesModule,
		PipeModule,
		IdlPipeModule,
		MatExpansionModule,
		TourneesModule,
		MatCheckboxModule,
		MatPaginatorModule,
		FormsModule,
		MatRadioModule,
		MatFormFieldModule,
		MatInputModule,
		MatTooltipModule,
		ScrollingModule,
		OrdonnancesModule,
		OlaqinModule,
		MatSelectModule,
		PatientsModule
	],
	providers: [
		FacturationService,
		{ provide: MatPaginatorIntl, useClass: CustomPaginator }
	]
})
export class FacturationModule { }